import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { LocationPermissionService } from '@/app/shared/services/location-permission.service';

@Component({
  selector: 'fw-location-settings-dialog',
  templateUrl: './location-settings-dialog.component.html',
  styleUrls: ['./location-settings-dialog.component.less'],
  imports: [TranslatePipe, DialogModule, ButtonModule],
})
export class LocationSettingsDialogComponent {
  protected readonly locationPermissionService = inject(LocationPermissionService);

  onTryAgain(): void {
    this.locationPermissionService.clearDeniedState();
    this.locationPermissionService.clearError();
    this.locationPermissionService.closeDialog();
    this.locationPermissionService.requestLocation(true);
  }
  
  onClose(): void {
    this.locationPermissionService.closeDialog();
  }
}
